import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PrivyProvider } from "@privy-io/react-auth";
import { BrowserRouter } from "react-router-dom";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";
import { Provider } from "react-redux";
import configureStore from "./store";
import "./i18n";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={configureStore}>
      <BrowserRouter>
        <PrivyProvider
          appId={process.env.REACT_APP_PRIVY_APP_ID}
          onSuccess={(user) => console.log(`User ${user.id} logged in!`)}
        >
          <SmartWalletsProvider>
            <App />
          </SmartWalletsProvider>
        </PrivyProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
